export function setPrinterGroups(state, val) {
  state.printerGroups = Array.isArray(val) ? val : [];
}
